// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SiteSvg from '@rsuite/icon-font/lib/layout/Site';
var Site = createSvgIcon({
  as: SiteSvg,
  ariaLabel: 'site',
  category: 'layout',
  displayName: 'Site'
});
export default Site;